import {createAction} from '@reduxjs/toolkit'

export const trackRedirectOfferViewed = createAction<{offerId: string}>(
  'analytics/redirectOfferViewed'
)

export const trackRedirectOfferClicked = createAction<{offerId: string}>(
  'analytics/redirectOfferClicked'
)
